import {HttpClient} from "../../service/httpClient/HttpClient";

export class ManagerAccessLevelService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getAccessLevelList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `realms/admin/roles`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getPermissionsList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `permissions/realms/admin`,
                {page, size}
            ).then(resolve).catch(reject)
        })
    }

    addNewRole(name, permissions) {

        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `realms/admin/roles`,
                {
                    name,
                    permissions
                }
            ).then(resolve).catch(reject)
        })


    }

    updateRoleInfo(id, name, permissions) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `realms/admin/roles/${id}`,
                {
                    name,
                    permissions
                }
            ).then(resolve).catch(reject)
        })
    }

    getRoleInfo(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `realms/admin/roles/${id}`
            ).then(resolve).catch(reject)
        })
    }
}

function renameKey(obj, oldKey, newKey) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
}